import { KCommandBase, CommandEnv } from 'components/cmdk/cmdkTypes'

type CommandRunAction = (env: CommandEnv) => void

export type KRun = KCommandBase & {
  run: CommandRunAction
}

export function toRunAction(this: KRun, env: CommandEnv) {
  const { run } = this
  return () => run(env)
}
